import { useStore } from "react-reducer-store"

/**
 * Returns current app id
 * @component
 * @category Hooks
 */
const useAppId = () => {
  const appStore = useStore(state => state.app)
  return appStore && appStore.appId
}

export default useAppId
